// extracted by mini-css-extract-plugin
export var imageRight = "imageRight-module--imageRight--eq1zo";